<template>
  <v-card>
    <v-card-text>
      <v-form v-model="isFormValid" ref="newCaptureForm">
        <v-row>
          <v-col cols="3" lg="3" sm="4">
            <v-menu
              v-model="isShipmentDatePickerOpen"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="capture.shipmentDate"
                  :label="$t('label.shipmentDate')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :rules="[rules.required]"
                  outlined
                  :disabled="showDataTable"
                  dense>
                </v-text-field>
              </template>
              <v-date-picker v-model="capture.shipmentDate" @input="isShipmentDatePickerOpen = false" :min="today"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3" lg="3" sm="4">
            <v-menu
              v-model="isTentativeDeliveryDatePickerOpen"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="capture.tentativeDeliveryDate"
                  :label="$t('label.tentativeDeliveryDate')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :rules="[rules.required]"
                  outlined
                  :disabled="showDataTable"
                  dense>
                </v-text-field>
              </template>
              <v-date-picker v-model="capture.tentativeDeliveryDate" @input="isTentativeDeliveryDatePickerOpen = false" :min="today"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3" lg="3" sm="4">
            <v-select v-model="capture.facilityId"
              :items="facilities"
              item-text="name"
              item-value="id"
              outlined
              dense
              :disabled="showDataTable"
              :loading="loading.facilities"
              :rules="[rules.required]"
              :label="$t('label.facility')">
            </v-select>
          </v-col>
          <v-col cols="3" lg="3" sm="4">
            <v-text-field
              v-model="capture.invoice"
              :label="$t('label.invoiceShipping')"
              outlined
              :disabled="showDataTable"
              :rules="[rules.notBlank, rules.printableAscii]"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="3" lg="3" sm="4">
            <v-text-field
              v-model="capture.lot"
              :label="$t('label.lot')"
              outlined
              :disabled="showDataTable"
              :rules="[rules.printableAscii]"
              dense
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn color="primary" depressed :loading="isLoading" :disabled="!isFormValid || showDataTable" @click="getPendingsToShip">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row v-if="showDataTable">
        <v-col cols="12">
          <h3>{{ $t('label.filters') }}</h3>
        </v-col>
        <v-col>
          <v-menu
            v-model="isToDatePickerOpen"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filters.toDate"
                :label="$t('label.toDate')"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense>
              </v-text-field>
            </template>
            <v-date-picker v-model="filters.toDate" @input="isToDatePickerOpen = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-text-field
            v-model="filters.partNumber"
            :label="$t('label.partNumber')"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            v-model="filters.purchaseOrder"
            :label="$t('label.purchaseOrder')"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <!-- <v-col v-if="userInfo.allowOtherVendorShipment">
          <v-select
            :items="vendors"
            item-text="vendorName"
            item-value="vendorCode"
            v-model="filters.vendorCode"
            :label="$t('label.vendor')"
            @change="onVendorChanged"
            outlined
            dense
            >
          </v-select>
        </v-col>
        <v-col v-if="shippingCodes.length > 0">
          <v-autocomplete
            :items="shippingCodes"
            item-text="vendorShippingCode"
            item-value="vendorShippingCode"
            v-model="filters.vendorShippingCode"
            :label="$t('label.vendorShippingCode')"
            outlined
            dense
          >
          </v-autocomplete>
        </v-col> -->
        <v-col>
          <v-btn :title="$t('label.clearFilters')" icon color="default" depressed @click="clearFilters">
            <v-icon color="gray">mdi-close-circle</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="showDataTable">
        <v-form ref="new" style="width: 99%;">
          <v-row class="justify-end">
            <v-btn small depressed color="secondary" class="mr-2" @click.stop="showMoreColumns">{{ showMore ? $t('label.showLessColumns') : $t('label.showMoreColumns') }}</v-btn>
            <v-btn small depressed color="error" class="mr-2" @click.stop="clearCapture">{{ $t('label.cancelCapture') }}</v-btn>
            <v-btn small depressed class="mr-2" @click.stop="fillAll">{{ $t('label.fillAll') }}</v-btn>
            <v-btn small depressed class="mr-2" @click.stop="clearAll">{{ $t('label.clearAll') }}</v-btn>
            <v-btn small depressed color="primary" class="mr-2" @click="isNewCaptureConfirmationDialogOpen=true" :disabled="!isTableFormValid">{{ $t('label.saveCapture') }}</v-btn>
          </v-row>
        </v-form>
      </v-row>
      <v-row v-if="showDataTable">
        <v-col>
          <v-form ref="tableForm" v-model="isTableFormValid">
            <v-data-table
              :headers="headers"
              :items="pendingsToShipFiltered"
              :options="options"
              :loading="isLoading"
              dense
              hide-default-footer
              disable-sort
              >
              <template v-slot:[`item.quantityToShip`]="{ item }">
                <v-text-field dense v-model="item.quantityToShip" :rules="[rules.required, rules.decimalQuantity3]"></v-text-field>
              </template>
              <template v-slot:[`item.vendorCode`]="{ item }">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on">
                      {{ item.vendorCode }}
                    </span>
                  </template>
                  <span>{{ item.vendorName }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.purchaseOrder="{ item }">
                <span>{{ item.purchaseOrder }}</span>&nbsp;<span v-show="item.vendorOrder.length > 0">({{ item.vendorOrder }})</span>
              </template>
              <template v-slot:item.line="{ item }">
                <span>{{ item.line }}</span>&nbsp;<span v-show="item.vendorShippingLine > 0">({{ item.vendorShippingLine }})</span>
              </template>
            </v-data-table>
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog v-model="isNewCaptureConfirmationDialogOpen" persistent max-width="500">
      <confirmation-dialog @confirm="confirmationNewCapture">
        <span v-html="$t('message.confirmation.saveCapture')"></span>
      </confirmation-dialog>
    </v-dialog>
    <v-dialog v-model="isExistingShipmentDialogOpen" persistent max-width="1500">
      <v-card>
        <v-card-title>{{ $t('message.info.existingInvoice') }}</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="existingShipment"
            dense
            hide-default-footer
          >
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small depressed color="default" @click.stop="clearCapture">{{ $t('label.cancelCapture') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openDownloadShippingDialog" persistent max-width="500">
      <v-card>
        <v-card-title>
          {{ $t('message.confirmation.shippingCreatedAndDownload', [shipmentId]) }}
        </v-card-title>
        <v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-spacer>
          </v-spacer>
          <v-btn small depressed @click="openDownloadShippingDialog = false">{{ $t('label.cancel') }}</v-btn>
          <v-btn small depressed @click="openDownloadShippingDialog = false; downloadShipping()" color="primary">{{ $t('label.download') }}</v-btn>
          <v-btn small depressed @click="openDownloadShippingDialog = false; isDetailDialogOpen = true" color="primary">{{ $t('label.customPrint') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isDetailDialogOpen" persistent width="1200">
      <shipment-detail :shipmentId="shipmentId" @close="isDetailDialogOpen = false" :print="true"></shipment-detail>
    </v-dialog>
  </v-card>
</template>

<script>
import { formatDate } from '../../../core/sharedFunctions'
import { rules, loading, showMessage, userInfo } from '../../../mixins'
import ConfirmationDialog from '../../Shared/ConfirmationDialog'
import ShipmentDetail from '../shipments/ShipmentDetail.vue'
import { saveAs } from 'file-saver'

export default {
  name: 'NewCaptureForm',
  mixins: [rules, loading, showMessage, userInfo],
  components: { ConfirmationDialog, ShipmentDetail },
  data: () => ({
    isDetailDialogOpen: false,
    isFormValid: null,
    isTableFormValid: null,
    showMore: false,
    shippingCodes: [],
    loading: {
      facilities: false
    },
    capture: {
      shipmentDate: '',
      tentativeDeliveryDate: '',
      facilityId: '',
      invoice: '',
      // instruction: '',
      lot: '',
      details: []
    },
    facilities: [],
    vendors: [],
    isShipmentDatePickerOpen: false,
    isTentativeDeliveryDatePickerOpen: false,
    isToDatePickerOpen: false,
    openDownloadShippingDialog: false,
    filters: {
      toDate: '',
      partNumber: '',
      purchaseOrder: '',
      vendorCode: '',
      vendorShippingCode: ''
    },
    options: {
      sortBy: ['purchaseOrder'],
      sortDesc: [false],
      itemsPerPage: -1
    },
    showDataTable: false,
    pendingsToShip: [],
    isNewCaptureConfirmationDialogOpen: false,
    isExistingShipmentDialogOpen: false,
    existingShipment: [],
    shipmentId: 0
  }),
  computed: {
    today () {
      return formatDate(new Date(), '-')
    },
    headers () {
      let headers = [
        { text: this.$t('label.requiredDateEdi'), value: 'requiredDateFormated', align: 'center' },
        { text: this.$t('label.shipDateEdi'), value: 'shipDateFormated', align: 'center' },
        { text: this.$t('label.vendor'), value: 'vendorCode', align: 'center' },
        { text: this.$t('label.partNumber'), value: 'partNumber', align: 'center' },
        { text: this.$t('label.purchaseOrder'), value: 'purchaseOrder', align: 'center' },
        { text: this.$t('label.line'), value: 'line', align: 'center' }
      ]
      if (this.shippingCodes.length > 0) {
        headers = [
          ...headers,
          { text: this.$t('label.vendorShippingCode'), value: 'vendorShippingCode', align: 'center' }
        ]
      }

      if (this.showMore) {
        headers = [
          ...headers,
          { text: this.$t('label.requiredQuantity'), value: 'requiredQuantity', align: 'center custom-color' },
          { text: this.$t('label.inTransitQuantity'), value: 'transitQuantity', align: 'center custom-color' },
          { text: this.$t('label.inShipmentQuantity'), value: 'inShipmentQuantity', align: 'center custom-color' },
          { text: this.$t('label.receivedQuantity'), value: 'confirmedQuantity', align: 'center custom-color' }
        ]
      }

      headers = [
        ...headers,
        { text: 'SNP', value: 'snp', align: 'center', width: 100 },
        { text: this.$t('label.unitOfMeasure'), value: 'unitOfMeasure', align: 'center' },
        { text: this.$t('label.balance'), value: 'pendingToShip', align: 'center' },
        { text: this.$t('label.quantityToShip'), value: 'quantityToShip', align: 'center', width: 120 }
      ]

      return headers
    },
    pendingsToShipFiltered () {
      const toDate = this.pendingsToShip ? parseInt(this.filters.toDate.replace(/-/g, '')) : null
      return this.pendingsToShip.filter(p =>
        (!this.filters.partNumber || p.partNumber.toLowerCase().includes(this.filters.partNumber.toLowerCase())) &&
        (!this.filters.purchaseOrder || p.purchaseOrder.toString().toLowerCase().includes(this.filters.purchaseOrder.toLowerCase())) &&
        (!this.filters.vendorCode || p.vendorCode === this.filters.vendorCode) &&
        (!this.filters.vendorShippingCode || p.vendorShippingCode === this.filters.vendorShippingCode) &&
        (!toDate || p.requiredDate <= toDate)
      )
    }
  },
  methods: {
    showMoreColumns () {
      this.showMore = !this.showMore
    },
    downloadShipping () {
      this.changeLoadingStatus(true)
      this.$proxy.getDownload(`api/edi/shipments/${this.shipmentId}/label`)
        .then((r) => {
          saveAs(r.data, `Shipment-${this.shipmentId}.pdf`)
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
          this.openDownloadShippingDialog = false
        })
    },
    getFacilities () {
      this.loading.facilities = true
      this.$proxy.get('api/edi/facilities')
        .then((r) => {
          this.facilities = r.data
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.loading.facilities = false
        })
    },
    getPendingsToShip () {
      this.clearFilters()
      this.shippingCodes = []
      if (!this.capture.invoice || this.capture.invoice.trim() === '') {
        this.showMessage(this.$t('message.error.invoiceOrInstructionRequired'))
        return
      }
      this.changeLoadingStatus(true)
      this.$proxy.get(`api/edi/releases/pendingtoship?facilityId=${this.capture.facilityId}&invoice=${this.capture.invoice}`)
        .then((r) => {
          this.pendingsToShip = r.data.pendingToShip
          const key = 'originVendorShippingCode'
          const redUniq = [
            ...r.data.pendingToShip
              .reduce((uniq, curr) => {
                if (!uniq.has(curr[key])) {
                  uniq.set(curr[key], curr)
                }
                return uniq
              }, new Map())
              .values()
          ]
          for (var i = 0; i < redUniq.length; i++) {
            if (redUniq[i].originVendorShippingCode === '') {
              redUniq.splice(i, 1)
            }
          }
          if (redUniq.length > 0) {
            this.shippingCodes = this.sortedItems(redUniq)
            this.pendingsToShip = this.sortedItems1(this.pendingsToShip)
          }
          this.existingShipment = r.data.existingShipment
          this.isExistingShipmentDialogOpen = r.data.invoiceExists
          this.showDataTable = true
          if (this.userInfo.allowOtherVendorShipment) {
            const vendorCodesSet = new Set(r.data.pendingToShip.map(x => x.vendorCode))
            const vendorCodes = Array.from(vendorCodesSet)
            this.vendors = vendorCodes.map(vendorCode => {
              const vendorName = r.data.pendingToShip.filter(y => y.vendorCode === vendorCode)[0].vendorName
              const fullName = `${vendorCode} - ${vendorName}`
              return { vendorCode, vendorName: fullName }
            })
            this.filters.vendorCode = this.userInfo.vendorCode
          }
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    sortedItems1 (sortedArray) {
      sortedArray.sort((a, b) => {
        let comparison = 0
        if (a.originVendorCodeLine < b.originVendorCodeLine) {
          comparison = -1
        } else if (a.originVendorCodeLine > b.originVendorCodeLine) {
          comparison = 1
        }
        return comparison
      })
      return sortedArray
    },
    sortedItems (sortedArray) {
      sortedArray.sort((a, b) => {
        let comparison = 0
        if (a.originVendorShippingCode < b.originVendorShippingCode) {
          comparison = -1
        } else if (a.originVendorShippingCode > b.originVendorShippingCode) {
          comparison = 1
        }
        return comparison
      })
      return sortedArray
    },
    onVendorChanged () {
      this.pendingsToShip = this.pendingsToShip.map(x => {
        x.quantityToShip = 0
        return x
      })
    },
    clearFilters () {
      this.filters = {
        toDate: '',
        partNumber: '',
        purchaseOrder: '',
        vendorCode: this.filters.vendorCode
      }
    },
    clearCapture () {
      this.capture = {
        shipmentDate: '',
        tentativeDeliveryDate: '',
        facilityId: '',
        invoice: '',
        // instruction: '',
        lot: '',
        details: [],
        shippingVendor: userInfo.vendorCode
      }
      this.$refs.newCaptureForm.resetValidation()
      this.showDataTable = false
      this.pendingsToShip = []
      this.isExistingShipmentDialogOpen = false
      this.existingShipment = []
      this.$refs.tableForm.resetValidation()
    },
    fillAll () {
      this.pendingsToShipFiltered.forEach(p => { p.quantityToShip = p.pendingToShip })
    },
    clearAll () {
      this.pendingsToShipFiltered.forEach(p => { p.quantityToShip = '0' })
    },
    confirmationNewCapture (confirm) {
      if (confirm) {
        this.saveCapture()
      }
      this.isNewCaptureConfirmationDialogOpen = false
    },
    saveCapture () {
      this.changeLoadingStatus(true)
      const purchaseOrders = {}
      // Convert text inputs to Integer and group by purchase order
      const details = this.pendingsToShip.map(p => {
        const detail = { ...p }

        purchaseOrders[detail.purchaseOrder] = purchaseOrders[detail.purchaseOrder] || []

        detail.quantityToShip = parseFloat(detail.quantityToShip)
        detail.snp = parseFloat(detail.snp)
        detail.pendingToShip = parseFloat(detail.pendingToShip)

        purchaseOrders[detail.purchaseOrder].push(detail)
        return detail
      })

      // Logica comentada *****
      // For each purchase order sort by line
      if (!this.shippingCodes.length > 0) {
        const purchaseOrderLines = Object.values(purchaseOrders)
        for (let i = 0; i < purchaseOrderLines.length; i++) {
          const lines = purchaseOrderLines[i]

          lines.sort((a, b) => {
            if (a.requiredDate > b.requiredDate) {
              return 1
            }
            if (b.requiredDate > a.requiredDate) {
              return -1
            }
            return 0
          })

          // lines.sort(orderBy('line'))
          // Cannot sent quantity for line if there are incomplete lines before
          let incompleteLine = false

          for (var j = 0; j < lines.length; j++) {
            const line = lines[j]

            if (incompleteLine && line.quantityToShip > 0) {
              this.showMessage(this.$t('message.error.incompletePOLines', [line.partNumber, line.line]))
              this.changeLoadingStatus(false)
              return
            }

            if (line.pendingToShip > line.quantityToShip) {
              incompleteLine = true
            }
          }
        }
      }

      // Logica comentada *****

      this.capture.details = details.filter(d => d.quantityToShip > 0)

      if (this.capture.details.length === 0) {
        this.showMessage(this.$t('message.error.noQuantitiesSpecified'))
        this.changeLoadingStatus(false)
        return
      }

      for (let i = 0; i < this.capture.details.length; i++) {
        const detail = this.capture.details[i]

        if (detail.snp <= 0) {
          this.showMessage(this.$t('message.error.noSnpSpecified'))
          this.changeLoadingStatus(false)
          return
        } else if ((detail.quantityToShip / detail.snp) > 999) {
          this.showMessage(this.$t('message.error.quantityLimit'))
          this.changeLoadingStatus(false)
          return
        }
        // if (detail.isSnpConfig) {
        //   if (detail.quantityToShip > (detail.pendingToShip + detail.toleranceUp)) {
        //     this.showMessage(this.$t('message.error.quantityToShipGreaterThanPendingToShip'))
        //     this.changeLoadingStatus(false)
        //     return
        //   }
        // }
        if (detail.isSnpConfig && detail.tolerance > 0) {
          const tolerance = detail.snp * (detail.tolerance / 100)

          const quotientTemp = Math.round(detail.quantityToShip / detail.snp)
          const quotient = quotientTemp === 0 ? 1 : quotientTemp

          const idealMultiple = quotient * detail.snp
          const maxTolerance = tolerance * quotient

          if (detail.quantityToShip > idealMultiple + maxTolerance) {
            this.showMessage(this.$t('message.error.maxTolerance', [idealMultiple + maxTolerance, detail.partNumber]))
            this.changeLoadingStatus(false)
            return
          }
          if (detail.quantityToShip < idealMultiple - maxTolerance) {
            this.showMessage(this.$t('message.error.minTolerance', [idealMultiple - maxTolerance, detail.partNumber]))
            this.changeLoadingStatus(false)
            return
          }

          // Si esta mas cerca del multiplo menor, aplicar la tolerancia maxima
          // if (detail.quantityToShip - idealMultiple < maxMultiple - detail.quantityToShip) {
          //   if (detail.quantityToShip > idealMultiple + tolerance) {
          //     this.showMessage(this.$t('message.error.maxTolerance', [idealMultiple + tolerance, detail.partNumber]))
          //     this.changeLoadingStatus(false)
          //     return
          //   }
          // } else {
          //   if (detail.quantityToShip < maxMultiple - tolerance) {
          //     this.showMessage(this.$t('message.error.minTolerance', [maxMultiple - tolerance, detail.partNumber]))
          //     this.changeLoadingStatus(false)
          //     return
          //   }
          // }
        } else {
          if (detail.quantityToShip > detail.pendingToShip) {
            this.showMessage(this.$t('message.error.quantityToShipGreaterThanPendingToShip'))
            this.changeLoadingStatus(false)
            return
          } else if ((detail.quantityToShip % detail.snp) !== 0 && !detail.isServicePart) {
            // Cantidad debe ser multiplo del SNP excepto para los registros de # de parte donde si se puede modificar el SNP
            this.showMessage(this.$t('message.error.quantityShouldBeMultipleOfSnp'))
            this.changeLoadingStatus(false)
            return
          }
        }
      }
      if (this.userInfo.allowOtherVendorShipment) {
        this.capture.vendorCode = this.filters.vendorCode
      } else {
        this.capture.vendorCode = this.userInfo.vendorCode
      }

      this.$proxy.post('api/edi/shipments/capture', this.capture)
        .then((res) => {
          if (res.data.shipmentId === -1) {
            if (this.$i18n.locale === 'en') {
              this.showMessage(res.data.messageEn)
            }
            if (this.$i18n.locale === 'es') {
              this.showMessage(res.data.messageEs)
            }
          } else {
            this.shipmentId = res.data.shipmentId
            this.openDownloadShippingDialog = true
            this.clearCapture()
          }
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    }
  },
  mounted () {
    this.getFacilities()
  }
}
</script>

<style scoped>
  .v-data-table /deep/ .custom-color {
    background-color: #f5f5f5;
  }

  .v-data-table /deep/ .v-data-table__wrapper {
    overflow: unset;
  }
</style>
